import { INSTANCE as FileDownloadManager } from '@core/transmission/FileDownloadManager'
import { INSTANCE as FileUploadManager } from '@core/transmission/FileUploadManager'
import { useSharedActiveMenuItem } from '@core/compositions/ActiveMenuItem'
import { createSharedComposable } from '@vueuse/core'
import { ref } from 'vue'

const needShowConfirmDialog = ref(false)
const onConfirm = ref<() => Promise<true | void>>()

const needConfirm = () => {
  const { isFileManager } = useSharedActiveMenuItem()

  return (FileUploadManager.hasUnfinishedTask() || FileDownloadManager.hasUnfinishedTask()) && isFileManager.value
}

const onCloseDialog = (isConfirmed: boolean) => {
  needShowConfirmDialog.value = false

  if (isConfirmed) {
    onConfirm.value?.()
  }
}

const switchApp = (onConfirmedNext: () => Promise<true | void>) => {
  const showConfirm = needConfirm()

  needShowConfirmDialog.value = showConfirm

  onConfirm.value = onConfirmedNext

  if (!showConfirm) {
    onConfirmedNext()
  }
}

const useAppSwitch = () => ({
  switchApp,
  onConfirm,
  needShowConfirmDialog,
  onCloseDialog,
})

export default createSharedComposable(useAppSwitch)
